var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolMenuHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 12,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 10,
    r: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolMenuHeader);
export default __webpack_public_path__ + "static/media/tool-menu-header.56930117b699780e750468b0167f83df.svg";
export { ForwardRef as ReactComponent };